<script setup lang="ts">
import { Skeleton } from '../ui/skeleton';

defineProps<{
	isLoading?: boolean;
}>();
</script>

<template>
	<Skeleton :is-active="true" variant="white" class="h-7 w-[396px]" />
	<div class="flex w-full flex-col rounded-lg bg-white-dark-1 p-7">
		<div class="flex flex-wrap gap-6">
			<div
				v-for="item in 6"
				:key="`design-architecture-skeleton-item-${item}`"
				class="w-full md:w-[calc(50%-12px)]"
			>
				<div class="relative flex flex-col gap-1">
					<!-- Title skeleton -->
					<Skeleton :is-active="true" variant="white" class="h-3 w-[110px]" />
					<!-- Value skeleton -->
					<Skeleton
						:is-active="true"
						variant="white"
						class="mt-1 h-3.5 w-[276px]"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
